import React, { useState, useEffect } from 'react';
import axios, { renderDoc, encryptData } from '../Axiosinstance';
import {
  TextField,
  Button,
  Grid,
  Typography,
  Container,
  Paper,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  InputLabel,
  Select,
  MenuItem,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  LinearProgress, Slide, CircularProgress
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import PhoneInput from 'react-phone-input-2'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Add } from '@mui/icons-material';
import dayjs from 'dayjs';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { confirmAlert } from 'react-confirm-alert';
// import 'react-confirm-alert/src/react-confirm-alert.css';
import { Modal } from 'react-bootstrap';
import * as pdfjs from "pdfjs-dist/build/pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import { buttonBackgroundColor } from '../common';

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;


function EditStudent({ studentId, onAction, from, pend }) {
  const [formData, setFormData] = useState({
    name: "",
    studentEmail: "",
    startModulus: "",
    enrollmentDate: "",
    enrolledDate: "",
    title: "",
    intake: "",
    designation: "",
    countryBirth: "",
    gender: '',
    dob: "",
    NRICno: "",
    nric: "",
    proofType: "",
    passportNo: "",
    addressOffice: "",
    addressHome: "",
    phoneOffice: "",
    phoneHome: "",
    handPhone: "",
    emergencyName: "",
    emergencyRelation: "",
    emergencyPhone: "",
    knowAboutProgram: "",
    applicationSignature: "",
    date: "",
    registrationFee: "",
    courseFee: "",
    otherDetails: "",
    referalfriend: "",
    company: "",
    photo: "",
    approve: "false",
    sessionId: null,
    sessionIdDate: null,
    //  amount: 1000,
    paymentStatus: "Pending",
    institutionDetails: [
      {
        institution: "",
        year: "",
        toYear: "",
        fullTimeOrPartTime: "",
        qualificationsAchieved: ""
      }
    ],
    profilePicture: '',
    markSheet: {

    },
    certificate: {

    },
    workPermitSpass: '',
    workPermitOne: '',
    passport: '',
    student: {

      name: '',
      fullname: '',
      nric: '',
      email: '',
      phone: '',
      password: '',
      address: '',
      postalcode: '',
      race: '',
      eduction: '',
      employmentstatus: '',
      salary: '',

      corporatecompanysponsored: '',
      batch: { id: "" },
      type: ""

    },
  });

  const [initialDate, setInitialDate] = useState(formData.enrolledDate);
  const [initialModulus, setInitialModulus] = useState(formData.startModulus)
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [approver, setApprover] = useState('')
  const [isApproving, setApproving] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [remark, setRemark] = useState('');
  const [batchSummary, setBatchSummary] = useState([]);
  const [loadingButton, setLoadingButton] = useState(null);
  const [selectedBatch, setSelectedBatch] = useState(null);

  useEffect(() => {
    axios
      .get("/batch-summary")
      .then((response) => {
        setBatchSummary(response.data);
        console.log(response.data, "batchsummary");
      })
      .catch((error) => console.error("Error fetching batch summary:", error));
  }, []);

  useEffect(() => {
    if (studentId) {
      axios.get(`registrationadvances/${studentId}`)
        .then(response => {
          setFormData(response.data);
          setInitialDate(response.data.enrolledDate);
          setInitialModulus(response.data.startModulus || 1);
          console.log(response.data)
        })
        .catch(error => {
          console.error("There was an error fetching the student data!", error);
        });
    }
  }, [studentId]);

  // const handleDateChange = (event) => {
  //   const { value } = event.target;
  //   const newDate = dayjs(value);
  //   const oldDate = dayjs(initialDate);

  //   // Calculate the difference in months between the old and new dates
  //   const monthDifference = newDate.diff(oldDate, 'month');

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (formData.type === 'diploma') {
  //     increment = Math.floor(monthDifference / 2); // Increment by 1 for every 2 months
  //   } else if (formData.type === 'advance_diploma') {
  //     increment = monthDifference; // Increment by 1 for every month
  //   }

  //   // Calculate the new modulus value
  //   let newModulus = initialModulus + increment;

  //   // Ensure the modulus value stays between 1 and 6
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;

  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrolledDate: value,
  //     startModulus: newModulus,
  //   }));
  // };

  // const handleDateChange = (event) => {
  //   // Get the new date from the event
  //   const { value } = event.target;
  //   console.log("Selected Enrollment Date:", value);

  //   const newDate = dayjs(value); // Create dayjs object from the new date
  //   const oldDate = dayjs(formData.enrolledDate);

  //   console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
  //   console.log("New Date:", newDate.format('YYYY-MM-DD'));

  //   // Calculate the difference in months between the old and new dates
  //   let monthDifference = newDate.month() - oldDate.month();
  //   if (newDate.year() !== oldDate.year()) {
  //     monthDifference += (newDate.year() - oldDate.year()) * 12;
  //   }
  //   console.log("Month Difference:", monthDifference);

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (formData.type === 'diploma') {
  //     increment = Math.floor(monthDifference / 2);
  //     console.log("Diploma Course - Increment:", increment);
  //   } else if (formData.type === 'advance_diploma') {
  //     increment = monthDifference;
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   }

  //   // Calculate the new modulus value based on the increment
  //   let newModulus = initialModulus + increment;
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Wrap around to keep it between 1 and 6
  //   console.log("New Modulus Before Ensuring Range:", newModulus);

  //   // Determine the first Saturday and Sunday of the month
  //   const firstSaturday = newDate.date(1).day(6); // First Saturday
  //   const firstSunday = newDate.date(1).day(7);   // First Sunday

  //   console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
  //   console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));



  //   // Adjust modulus based on the type and day checks
  //   if (formData.type === 'diploma') {
  //     const isEvenMonth = (newDate.month() + 1) % 2 === 0; // Check if the month is even
  //     console.log("Is Even Month:", isEvenMonth);

  //     if (isEvenMonth) {
  //       // For even months, just add 1 to newModulus
  //       newModulus += 1;
  //       console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
  //     } else {
  //       // For odd months, check if the new date is after the first Saturday or Sunday
  //       if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
  //         newModulus += 1;
  //         console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after the first Saturday/Sunday.");
  //       }
  //     }
  //   } else if (formData.type === 'advance_diploma') {
  //     // Check if the new date is after the first Sunday
  //     if (newDate.isAfter(firstSunday)) {
  //       newModulus += 1;
  //       console.log("Advance Diploma - Adjusting Modulus by adding 1.");
  //     }
  //   }

  //   // Ensure modulus value stays within the 1-6 range after adjustments
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;

  //   // Update the form data with the new values
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrolledDate: value,
  //     startModulus: newModulus,
  //   }));
  //   console.log("newModulus:", newModulus);
  //   console.log("Updated Form Data:", {
  //     ...formData,
  //     enrolledDate: value,
  //     startModulus: newModulus,
  //   });
  // };
  // const handleDateChange = (event) => {
  //   const { value } = event.target;
  //   const newDate = dayjs(value);
  //   const oldDate = dayjs(initialDate);

  //   // Helper to find the first Sunday of the month
  //   const getFirstSunday = (date) => {
  //     let firstSunday = date.startOf('month');
  //     while (firstSunday.day() !== 0) { // 0 is Sunday in Day.js
  //       firstSunday = firstSunday.add(1, 'day');
  //     }
  //     return firstSunday;
  //   };

  //   // Determine the effective month based on the first Sunday
  //   const getEffectiveMonth = (date) => {
  //     const firstSunday = getFirstSunday(date);
  //     return date.isAfter(firstSunday)
  //       ? date.add(1, 'month').startOf('month')
  //       : date.startOf('month');
  //   };

  //   // Calculate effective months for both dates
  //   const oldEffective = getEffectiveMonth(oldDate);
  //   const newEffective = getEffectiveMonth(newDate);

  //   // Month difference between effective months
  //   const deltaMonths = newEffective.diff(oldEffective, 'month');

  //   // Determine the increment based on the type
  //   let increment = 0;
  //   if (formData.type === 'diploma') {
  //     increment = Math.floor(deltaMonths / 2); // Increment by 1 for every 2 months
  //   } else if (formData.type === 'advance_diploma') {
  //     increment = deltaMonths; // Increment by 1 for every month
  //   }

  //   // Calculate the new modulus value
  //   let newModulus = initialModulus + increment;

  //   // Ensure the modulus value stays between 1 and 6
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure 1-6
  //   console.log("newModulus", newModulus)
  //   // Update state with new values
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrolledDate: value,
  //     startModulus: newModulus,
  //   }));
  // };

  // const handleDateChange = (event) => {
  //   const { value } = event.target;
  //   const newDate = dayjs(value);
  //   // const oldDate = dayjs(initialDate);
  //   const oldDate = dayjs(initialDate);
  //   // Helper to find the first Sunday of the month
  //   const getFirstSunday = (date) => {
  //     let firstSunday = date.startOf('month');
  //     while (firstSunday.day() !== 0) { // 0 is Sunday in Day.js
  //       firstSunday = firstSunday.add(1, 'day');
  //     }
  //     return firstSunday;
  //   };

  //   const getFirstSaturday = (date) => {
  //     let firstSaturday = date.startOf('month');
  //     while (firstSaturday.day() !== 6) { // 6 is Saturday in Day.js
  //       firstSaturday = firstSaturday.add(1, 'day');
  //     }
  //     return firstSaturday;
  //   };

  //   // Determine the effective month based on type
  //   const getEffectiveMonth = (date, type) => {
  //     if (type === "advance_diploma") {
  //       // Use first Sunday for advance diploma
  //       const firstSunday = getFirstSunday(date);
  //       return date.isAfter(firstSunday)
  //         ? date.add(1, 'month').startOf('month')
  //         : date.startOf('month');
  //     } else if (type === "diploma") {
  //       // Use first Saturday for diploma
  //       const firstSaturday = getFirstSaturday(date);
  //       return date.isAfter(firstSaturday)
  //         ? date.add(1, 'month').startOf('month')
  //         : date.startOf('month');
  //     }
  //     // Default case (if type is unknown)
  //     return date.startOf('month');
  //   };


  //   const oldEffective = getEffectiveMonth(oldDate, formData?.type);
  //   const newEffective = getEffectiveMonth(newDate, formData?.type);

  //   // Month difference between effective months
  //   const deltaMonths = newEffective.diff(oldEffective, 'month');


  //   let increment = 0;
  //   if (formData?.type === 'diploma') {
  //     // Check if the oldDate month is odd or even
  //     if (oldDate.month() % 2 === 1) {
  //       // For odd months, increment by 1 for every odd month difference
  //       increment = Math.floor((deltaMonths + 1) / 2);

  //     } else {
  //       // For even months, increment by 1 for every 2 months
  //       increment = Math.floor(deltaMonths / 2);
  //     }
  //     console.log("Diploma Course - Increment:", increment);
  //   } else if (formData?.type === 'advance_diploma') {
  //     // For advance diploma, increment by the full month difference
  //     increment = deltaMonths;
  //     console.log("Advance Diploma Course - Increment:", increment);
  //   } else {
  //     console.warn("Unknown formData.type detected:", formData?.type);
  //   }

  //   // Calculate the new modulus value
  //   let newModulus = initialModulus + increment;

  //   if (formData?.type === 'diploma' && (oldDate.month() + 1) % 2 === 1) {
  //     // For odd months, we can apply an adjustment, e.g., add 1 before calculation
  //     newModulus += 1;
  //     console.log("Adjusted Modulus for Odd Month (Diploma):", newModulus);
  //   }

  //   // Ensure the modulus value stays between 1 and 6
  //   newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure 1-6
  //   console.log("newModulus", newModulus)
  //   // Update state with new values
  //   setFormData(prevFormData => ({
  //     ...prevFormData,
  //     enrolledDate: value,
  //     startModulus: newModulus,
  //   }));
  // };

  const handleDateChange = (event, batch) => {

    const matchingBatch = batchSummary.find(item => item.id === batch.id);

    const { value } = event.target;
    const newDate = dayjs(value);
    const oldDate = dayjs();

    const intakeStartDate = matchingBatch?.intakeStartDate ? dayjs(matchingBatch.intakeStartDate) : null;
    const isDatePassed = intakeStartDate && newDate.isAfter(intakeStartDate);

    // console.log("Intake Start Date:", intakeStartDate?.format('YYYY-MM-DD'));
    // console.log("Is Date Passed Intake Start Date?", isDatePassed);
    // console.log("selectedBatch", selectedBatch);

    if (matchingBatch?.status && newDate.isBefore(oldDate, 'day') && intakeStartDate) {
      // toast.error("Enrollment date cannot be before today.");
      alert("Enrollment date cannot be before today.")
      return;
    } else if (matchingBatch?.status && isDatePassed) {
      alert("Batch is not started yet.");
      return;
    } else if (matchingBatch?.status && !isDatePassed) {
      console.log("Batch is active. Using current module:", matchingBatch?.currentModule);
      // Exit function
      setFormData(prevFormData => ({
        ...prevFormData,
        enrolledDate: event.target.value,
        startModulus: matchingBatch.currentModule,
      }));
      return;
    }



    console.log("Current Date:", oldDate.format('YYYY-MM-DD'));
    console.log("New Date:", newDate.format('YYYY-MM-DD'));
    console.log("New Date Valid?", newDate.isValid());

    // Check for invalid date handling
    if (!newDate.isValid()) {
      console.error("Invalid newDate detected. Check input format.");
      return;
    }

    let monthDifference = newDate.month() - oldDate.month();
    if (newDate.year() !== oldDate.year()) {
      monthDifference += (newDate.year() - oldDate.year()) * 12;
    }
    console.log("Month Difference:", monthDifference);

    console.log("Form Data Type:", formData?.type);

    let increment = 0;
    if (formData?.type === 'diploma') {
      // Check if the oldDate month is odd or even
      if (oldDate.month() % 2 === 1) {
        // For odd months, increment by 1 for every odd month difference
        increment = Math.floor((monthDifference + 1) / 2);
      } else {
        // For even months, increment by 1 for every 2 months
        increment = Math.floor(monthDifference / 2);
      }
      console.log("Diploma Course - Increment:", increment);
    } else if (formData?.type === 'advance_diploma') {
      // For advance diploma, increment by the full month difference
      increment = monthDifference;
      console.log("Advance Diploma Course - Increment:", increment);
    } else {
      console.warn("Unknown formData.type detected:", formData?.type);
    }

    console.log("Initial Modulus:", matchingBatch?.currentModule);

    // Adjust the modulus based on the increment
    let newModulus = matchingBatch?.currentModule + increment;
    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1; // Ensure modulus stays within 1-6
    console.log("New Modulus After Adjustments:", newModulus);

    const firstDayOfMonth = newDate.date(1);

    const firstSaturday = firstDayOfMonth.day(6).isBefore(firstDayOfMonth)
      ? firstDayOfMonth.day(6 + 7)
      : firstDayOfMonth.day(6);

    const firstSunday = firstDayOfMonth.add((7 - firstDayOfMonth.day()) % 7, "day");

    console.log("First Saturday of the Month:", firstSaturday.format('YYYY-MM-DD'));
    console.log("First Sunday of the Month:", firstSunday.format('YYYY-MM-DD'));

    console.log("before updating  New Modulus:", newModulus);

    if (formData?.type === 'diploma') {
      const isEvenMonth = (newDate.month() + 1) % 2 === 0;
      console.log("Is Even Month:", isEvenMonth);

      if (isEvenMonth) {
        newModulus += 1;
        console.log("Diploma - Even Month: Adjusting Modulus by adding 1.");
      } else {
        if (newDate.isAfter(firstSaturday) || newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Diploma - Odd Month: Adjusting Modulus by adding 1 after first Saturday/Sunday.");
        }
      }
    }
    else if (formData?.type === 'advance_diploma') {

      console.log((oldDate.month()), "oldDate");
      console.log((oldDate.month() + 1) % 2, "oldDate");
      if ((oldDate.month() + 1) % 2 === 1) {
        if (newDate.isAfter(firstSunday)) {
        newModulus += 1;
        console.log("Advance Diploma - Adjusting Modulus by adding 1.");
      }
      }

      else if ((oldDate.month() + 1) % 2 === 0) {
        if (newDate.isAfter(firstSunday)) {
          newModulus += 1;
          console.log("Advance Diploma - Adjusting Modulus by adding 1.", (oldDate.month()));

        }
        else {
          newModulus = newModulus;
          console.log("hiihih", (oldDate.month()));
        }
      }

    }

    newModulus = ((newModulus - 1) % 6 + 6) % 6 + 1;
    console.log("Final New Modulus:", newModulus);

    // Update state with new values
    setFormData(prevFormData => ({
      ...prevFormData,
      enrolledDate: value,
      startModulus: newModulus,
    }));
  };


  const [isEdited, setIsEdited] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    setIsEdited(true);
  };

  // const SUPPORTED_FILE_TYPES = [
  //   'image/jpeg',
  //   'image/png',
  //   'application/pdf',
  //   'application/msword',
  //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // ];


  const CLOUDINARY_URL = 'https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload';
  const CLOUDINARY_UPLOAD_PRESET = 'vldqgwk8';

  const handleFileUpload = async (event, docType, index = null) => {
    const file = event.target.files[0];
    if (!file) return;

    // Allowed file types for normal uploads
    const SUPPORTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf'];

    if (!SUPPORTED_FILE_TYPES.includes(file.type)) {
      toast.error('Error: Unsupported file type! Please upload a .jpg, .jpeg, .png, or .pdf file.', {
        style: {
          backgroundColor: '#fff',
          color: 'black',
          fontWeight: 'normal',
        }
      });

      if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [docType.startsWith("markSheet") ? "markSheet" : "certificate"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheet" : "certificate"],
            [`level${index + 1}Status`]: 'Error: Unsupported file type',
            [`level${index + 1}Progress`]: 0,
          },
          [docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"]: {
            ...prevFormData[docType.startsWith("markSheet") ? "markSheetFileNames" : "certificateFileNames"],
            [`level${index + 1}`]: '',
          }
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [`${docType}Status`]: 'Error: Unsupported file type',
          [`${docType}Progress`]: 0,
          [`${docType}FileName`]: '',
        }));
      }

      return;
    }

    // If the file is a PDF and docType is profilePicture, convert to JPG
    if (file.type === 'application/pdf' && docType === 'profilePicture') {
      try {
        const firstPageJpgBlob = await convertPdfToJpg(file);
        const jpgFile = new File([firstPageJpgBlob], "converted-profile.jpg", { type: "image/jpeg" });

        // Upload the converted JPG file
        await uploadFile(jpgFile, docType, index);
      } catch (error) {
        console.error("Error converting PDF to JPG:", error);
        toast.error('Error converting PDF. Please try again.');
      }
    } else {
      // Upload normal file (JPG, PNG, etc.)
      await uploadFile(file, docType, index);
    }
  };

  // Function to upload file to Cloudinary
  const uploadFile = async (file, docType, index = null) => {
    setLoadingButton(docType);
    const uploadFormData = new FormData();
    uploadFormData.append('file', file);
    uploadFormData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    try {
      const response = await fetch(CLOUDINARY_URL, {
        method: 'POST',
        body: uploadFormData,
      });

      if (response.ok) {
        const data = await response.json();

        if (docType.startsWith("markSheet") || docType.startsWith("certificate")) {
          const isMarkSheet = docType.startsWith("markSheet");
          const section = isMarkSheet ? "markSheet" : "certificate";
          const fileNameKey = isMarkSheet ? "markSheetFileNames" : "certificateFileNames";

          setFormData((prevFormData) => ({
            ...prevFormData,
            [section]: {
              ...prevFormData[section],
              [`level${index + 1}`]: data.secure_url,
              [`level${index + 1}Progress`]: 100,
              [`level${index + 1}Status`]: 'Uploaded',
            },
            [fileNameKey]: {
              ...prevFormData[fileNameKey],
              [`level${index + 1}`]: file.name,
            }
          }));
        } else {
          setFormData((prevFormData) => ({
            ...prevFormData,
            [docType]: data.secure_url,
            [`${docType}Progress`]: 100,
            [`${docType}Status`]: 'Uploaded',
            [`${docType}FileName`]: file.name,
          }));
        }
        console.log(`${docType} uploaded successfully: ${data.secure_url}`);
      } else {
        toast.error('Error uploading file');
      }
    } catch (error) {
      toast.error('Error uploading file');
    } finally {
      setLoadingButton(null);
    }
  };

  // Function to convert first page of a PDF to JPG
  const convertPdfToJpg = async (pdfFile) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(pdfFile);

      reader.onload = async () => {
        const pdfData = new Uint8Array(reader.result);
        const pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;
        const page = await pdf.getPage(1);

        const scale = 2;
        const viewport = page.getViewport({ scale });
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = viewport.width;
        canvas.height = viewport.height;

        const renderContext = { canvasContext: context, viewport };
        await page.render(renderContext).promise;

        canvas.toBlob((blob) => {
          if (blob) resolve(blob);
          else reject("Error converting PDF page to image");
        }, "image/jpeg");
      };

      reader.onerror = (error) => reject(error);
    });
  };

  const resetUpload = (docType) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [`${docType}Progress`]: 0,
      [`${docType}Status`]: '',
      [`${docType}FileName`]: ''
    }));
  };




  const isImage = (src) => src && src.match(/\.(jpeg|jpg|gif|png)$/i) != null;
  const isPDF = (src) => src && src.match(/\.(pdf)$/i) != null;
  const isDoc = (src) => src && src.match(/\.(doc|docx)$/i) != null;

  const [open, setOpen] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const validateEmail = (value) => {
    // Example validation: Check if value is a valid email format
    return /\S+@\S+\.\S+/.test(value);
  };

  const validatePassword = (value) => {
    // Example validation: Check if value meets minimum length requirement
    return value.length >= 8;
  };

  const validatePassportNumber = (value) => {
    // Validate if value is alphanumeric and within specified length
    return /^[a-zA-Z0-9]{8,9}$/.test(value);
  };

  const handleInstitutionChange = (index, e) => {
    const { name, value } = e.target;
    const newInstitutionDetails = formData.institutionDetails.map((institution, i) => {
      if (i === index) {
        return { ...institution, [name]: value };
      }
      return institution;
    });
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails
    });
    setIsEdited(true);
  };

  const addInstitution = () => {
    setFormData({
      ...formData,
      institutionDetails: [
        ...formData.institutionDetails,
        {
          institution: "",
          // toYear: "",
          year: "",
          fullTimeOrPartTime: "",
          qualificationsAchieved: ""
        }
      ]
    });
  };

  const handleKnowAboutProgramChange = (event) => {
    const value = event.target.value;
    setFormData((prevData) => ({
      ...prevData,
      knowAboutProgram: value,
      otherDetails: value === 'other' ? prevData.otherDetails : '', // Keep otherDetails if "other" is selected
      referalfriend: value === 'referral' ? prevData.referalfriend : '' // Keep referalfriend if "referral" is selected
    }));
  };
  const handleOtherDetailsChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      otherDetails: event.target.value
    }));
  };
  const handleReferalFriendChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      referalfriend: event.target.value
    }));
  };

  const removeInstitution = (index) => {
    const newInstitutionDetails = formData.institutionDetails.filter((_, i) => i !== index);
    setFormData({
      ...formData,
      institutionDetails: newInstitutionDetails
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); // Start loading state

    axios.put(`registrationadvances/${studentId}`, formData)
      .then(response => {
        console.log("First API response:", response.data);

        // Now, make the second axios.put request
        //   return axios.put(`/home/${formData.student.id}/activate`, null, {
        //     params: {
        //       registrationAdvanceId: studentId
        //     }
        //   }
        // );
      })
      .then(response => {
        console.log("Second API response:", response.data);
        setSubmissionSuccess(true); // Indicate success
        setLoading(false); // End loading state
      })
      .catch(error => {
        console.error("There was an error with one of the API requests!", error);
        setLoading(false); // End loading state
      })
      .finally(() => {
        //   setOpen(true); // Open the dialog
        const escEvent = new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27 });
        document.dispatchEvent(escEvent);
      });
  };

  const moduleDetailsMap = {};
  formData.batch?.moduleDetails.forEach((module) => {
    moduleDetailsMap[module.id] = module.moduleName;
  });

  const handleApproveClick = async (formData) => {
    const isConfirmed = window.confirm("Are you sure you want to approve this student?");
    if (isConfirmed) {
      setSelectedStudent(formData);
      await handleApprove(formData);
    }
  };

  useEffect(() => {

    const storedName = localStorage.getItem('name');
    if (storedName) {
      setApprover(storedName);
    }
  }, []);


  const handleSave = () => {
    // Perform save operation...
    toast.success("Saved successfully!");
    setIsEdited(true); // Reset edit tracking after saving
  };
  const handleapprove = () => {
    // Perform approve operation...
    pend ? handleActivateClick(formData) : handleApproveClick(formData);
    setIsEdited(true); // Reset edit tracking after approval
  };

  const handleApprove = async (formData) => {
    setApproving(true);
    try {
      const { id } = formData; // Use formData instead of selectedStudent

      // Encrypt data to be used in the URL
      const dataToEncrypt = { id: id };
      const encryptedData = encryptData(dataToEncrypt);

      // Construct the URL with encrypted data
      const pdfurl = `${window.location.origin}/paymentspage?data=${encodeURIComponent(encryptedData)}`;

      // Send invoice with the constructed URL as a parameter
      const loggedInUserId = localStorage.getItem('loggedInUserId');
      const name = localStorage.getItem('name');

      await axios.post(`/registrationadvances/sendInvoice`, null, {
        params: {
          Id: id,
          pdfUrl: pdfurl,
          approver: name,
          approverId: loggedInUserId
        }
      });

      toast.success('Student approved and activated successfully');

    } catch (error) {
      console.error('Error approving student:', error);
      toast.error('Error approving student');
    } finally {
      setApproving(false);
      onAction();
      const escEvent = new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27 });
      document.dispatchEvent(escEvent);
    }
  };

  const handleActivateClick = (formData) => {
    console.log(formData)
    setSelectedStudent(formData);
    setIsConfirmModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedStudent(null);
  };

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
    setRemark('');
    setSelectedStudent(null);
  };

  const handleActivateStudent = async () => {
    if (selectedStudent) {
      const data = {
        registrationId: selectedStudent.id,
        status: 'active',
      };

      // Ensure remark is not empty or null
      if (remark === null || remark.trim() === '') {
        toast.error('Remarks cannot be empty.');
        return; // Exit the function if remarks are empty or null
      }

      if (remark) {
        data.remarks = remark;
      }

      try {
        const response = await axios.put('registrationadvances/update-status', data);
        toast.success('Student status updated successfully');

        // Optionally fetch the updated list of students
        // fetchStudents(); 

        closeConfirmModal();
      } catch (error) {
        console.error('Error updating student status:', error);
        toast.error('Error updating student status');
      } finally {
        // Trigger ESC key event after the operation
        window.location.reload()

      }
    }
  };

  const maskNRIC_FIN = (value) => {
    if (!value) return "";
    let masked = value.slice(0, -4).replace(/\w/g, "*"); // Replace all but last 4 characters with *
    return masked + value.slice(-4); // Append the last 4 characters
  };


  return (
    <Container component="main" maxWidth="md">

      {/* <Typography variant="h4" gutterBottom>Edit Student</Typography> */}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3} justifyContent="center">
          {/* Basic Information */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Full Name (as per NRIC/Work pass)"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal" >
              <InputLabel id="id-type-label">NRIC/FIN</InputLabel>
              <Select
                labelId="id-type-label"
                label="NRIC/FIN"
                name="proofType"
                value={formData.proofType}
                onChange={handleChange}
                required
              >
                <MenuItem value="NRIC">NRIC</MenuItem>
                <MenuItem value="FIN">FIN</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* <TextField
                fullWidth
                label="NRIC/FIN"
                name="nric"
                value={formData.proofType}
                onChange={handleChange}
                required
                margin="normal"
              /> */}

          {/* {formData.proofType && (
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label={formData.proofType === 'NRIC' ? 'NRIC' : 'FIN'}
                  name={formData.proofType === 'NRIC' ? 'nric' : 'fin'}
                  value={formData.proofType === 'NRIC' ? formData.nric : formData.nric}
                  onChange={handleChange}
                  required
                  // margin="normal"
                  inputProps={{ maxLength: 20 }}
                />
              </Grid>
            )} */}

          {formData.proofType && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={formData.proofType === "NRIC" ? "NRIC" : "FIN"}
                name='nric'
                value={
                  formData.nric
                }
                onChange={handleChange}
                required
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Registration Fee"
              name="registrationFee"
              value={formData.registrationFee}
              onChange={handleChange}
              required
            />

          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              type="number"
              label="Course Fee"
              name="courseFee"
              value={formData.courseFee}
              onChange={handleChange}
              required
            />

          </Grid>


          <Grid item xs={12} sm={6}>
            <FormControl fullWidth >
              <InputLabel id="batchcode-label">Select Course</InputLabel>
              <Select
                labelId="batchcode-label"
                value={formData.batch?.id || ""}
                label="Select Batch"
                onChange={(event) => {
                  const selected = batchSummary.find(batch => batch.id === event.target.value);

                  setSelectedBatch(selected);

                  setFormData(prev => ({
                    ...prev,
                    batch: selected, // ⬅️ Full batch object here
                    type: selected.type,
                  }));
                }}

              >
                {batchSummary.map((batch) => (
                  <MenuItem key={batch.id} value={batch.id}>
                    {batch.batchcode}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Start Module"
              name="startModulus"
              value={moduleDetailsMap[formData.startModulus]}
              // onChange={handleDateChange}

              onChange={(e) => handleDateChange(e, formData.batch)}
              InputProps={{ readOnly: true }} // Make this field read-only
              InputLabelProps={{ shrink: true }} // Force label to shrink
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Enrollment Date"
                name="enrolledDate"
                type="date"
                InputLabelProps={{ shrink: true }}
                value={formData.enrolledDate}
                // onChange={handleDateChange}

                onChange={(e) => handleDateChange(e, formData.batch)}
              />
            </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Enrollment Date"
              name="enrolledDate"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.enrolledDate}
              onChange={(e) => handleDateChange(e, formData.batch)}
              disabled={!from} // disable if 'from' is falsy
            />
          </Grid>


          {/* Contact Information */}


          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Email "
              name="email"
              // type="email"
              value={formData.email}
              onChange={handleChange}
              // required
              InputLabelProps={{ shrink: true }}
              error={formData.email && !validateEmail(formData.email)}
              helperText={formData.email && !validateEmail(formData.email) ? 'Invalid email format' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth required>
              <InputLabel id="gender-label">Gender</InputLabel>
              <Select
                labelId="gender-label"
                label="Gender "
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <MenuItem value=""><em>Select</em></MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Date of Birth"
              name="dob"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.dob}
              onChange={handleChange}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type="password"
                value={formData.student.password}
                onChange={handleChange}
                required
                error={formData.password && !validatePassword(formData.password)}
                helperText={formData.password && !validatePassword(formData.password) ? 'Password must be at least 8 characters' : ''}
              />
            </Grid> */}

          {/* Address & Emergency Contact */}
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Nationality"
              name="countryBirth"
              value={formData.countryBirth}
              onChange={handleChange}
              required
              inputProps={{ maxLength: 20 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Passport Number"
              name="passportNo"
              value={formData.passportNo}
              onChange={handleChange}
              required
              error={formData.passportNo && !validatePassportNumber(formData.passportNo)}
              helperText={formData.passportNo && !validatePassportNumber(formData.passportNo) ? 'Alphanumeric, 8-9 characters' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Home Address"
              name="addressHome"
              value={formData.addressHome}
              onChange={handleChange}
              required
            />

          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth style={{ position: "relative" }}>
              <FormLabel
                style={{
                  position: "absolute",
                  top: "-8px",
                  left: "12px",
                  fontSize: "0.75rem",
                  color: "#666",
                  backgroundColor: "white",
                  padding: "0 5px",
                  zIndex: 1, // Ensures it stays above the input field
                }}
              >
                Mobile Phone*
              </FormLabel>
              <PhoneInput
                placeholder="Mobile Phone"
                // specialLabel="Mobile Phone*"
                country={'sg'}
                value={formData.handPhone}
                onChange={(value, country) => setFormData({
                  ...formData,
                  handPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                })}
                inputStyle={{
                  height: "58px",
                  width: "100%",
                  borderRadius: "5px",
                  paddingLeft: "48px",
                  paddingTop: "14px", // Creates space for floating label
                }}
                dropdownStyle={{ width: '250px' }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth style={{ position: "relative" }}>
              <FormLabel
                style={{
                  position: "absolute",
                  top: "-8px",
                  left: "12px",
                  fontSize: "0.75rem",
                  color: "#666",
                  backgroundColor: "white",
                  padding: "0 5px",
                  zIndex: 1, // Ensures it stays above the input field
                }}
              >
                Home Phone*
              </FormLabel>
              <PhoneInput
                placeholder="Home Phone"
                // specialLabel="Home Phone*"
                country={'sg'}
                value={formData.phoneHome}
                onChange={(value, country) => setFormData({
                  ...formData,
                  phoneHome: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                })}
                inputStyle={{
                  height: "58px",
                  width: "100%",
                  borderRadius: "5px",
                  paddingLeft: "48px",
                  paddingTop: "14px", // Creates space for floating label
                }}
                dropdownStyle={{ width: '250px' }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Emergency Contact Name"
              name="emergencyName"
              value={formData.emergencyName}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth required>
              <InputLabel id="emergency-relation-label">Emergency Contact Relation</InputLabel>
              <Select
                labelId="emergency-relation-label"
                name="emergencyRelation"
                value={formData.emergencyRelation}
                onChange={handleChange}
                required
                label="Emergency Contact Relation"
              >
                <MenuItem value="Friends">Friends</MenuItem>
                <MenuItem value="Colleague">Colleague</MenuItem>
                <MenuItem value="Parents">Parents</MenuItem>
                <MenuItem value="Others">Others</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {formData.emergencyRelation === 'Others' && (
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                name="emergencyOtherDetails"
                label="Please Specify Relation Name"
                value={formData.emergencyOtherDetails}
                onChange={handleChange}
              // margin="normal"
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth style={{ position: "relative" }}>

              <FormLabel
                style={{
                  position: "absolute",
                  top: "-8px",
                  left: "12px",
                  fontSize: "0.75rem",
                  color: "#666",
                  backgroundColor: "white",
                  padding: "0 5px",
                  zIndex: 1, // Ensures it stays above the input field
                }}
              >
                Emergency Contact number*
              </FormLabel>
              <PhoneInput
                placeholder="Emergency Contact number"
                specialLabel="Emergency Contact number*"
                country={'sg'}
                value={formData.emergencyPhone}
                onChange={(value, country) => setFormData({
                  ...formData,
                  emergencyPhone: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                })}
                inputStyle={{
                  height: "58px",
                  width: "100%",
                  borderRadius: "5px",
                  paddingLeft: "48px",
                  paddingTop: "14px", // Creates space for floating label
                }}
                dropdownStyle={{
                  width: '250px'
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth required>
              <InputLabel id="know-about-program-label">How Did You Know About the Program?</InputLabel>
              <Select
                labelId="know-about-program-label"
                name="knowAboutProgram"
                value={formData.knowAboutProgram}
                onChange={handleKnowAboutProgramChange}
                label="How Did You Know About the Program?"
              >
                <MenuItem value="referral">Friends</MenuItem>
                <MenuItem value="Jurong Academy Website">Jurong Academy Website</MenuItem>
                <MenuItem value="Flyers">Flyers</MenuItem>
                <MenuItem value="Newspaper Advertisement">Newspaper Advertisement</MenuItem>
                <MenuItem value="other">Others</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item sm={12} >
            {formData.knowAboutProgram === 'other' && (
              <TextField
                fullWidth
                name="otherDetails"
                label="Please Specify"
                value={formData.otherDetails}
                onChange={handleOtherDetailsChange}
                style={{ marginBottom: "16px" }}
              />
            )}

            {formData.knowAboutProgram === 'referral' && (
              <TextField
                fullWidth
                name="referalfriend"
                label="Please Specify Name "
                value={formData.referalfriend}
                onChange={handleReferalFriendChange}
              />
            )}
          </Grid>



          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: "bold" }}>Company Details</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Company Name"
              name="company"
              value={formData.company}
              onChange={handleChange}
              // required
              type='text'
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Designation"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
              // required
              type='text'
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6} style={{ marginTop: '-15px' }}>
            <TextField
              fullWidth
              label="Company Address"
              name="addressOffice"
              value={formData.addressOffice}
              onChange={handleChange}
              // required
              type='text'
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6} margin="normal">
            <FormControl fullWidth style={{ position: "relative" }}>
              <FormLabel
                style={{
                  position: "absolute",
                  top: "-8px",
                  left: "12px",
                  fontSize: "0.75rem",
                  color: "#666",
                  backgroundColor: "white",
                  padding: "0 5px",
                  zIndex: 1, // Ensures it stays above the input field
                }}
              >
                Company Contact*
              </FormLabel>
              <PhoneInput
                placeholder="Company Contact"
                specialLabel="Company Contact*"
                country={'sg'}
                value={formData.phoneOffice}
                onChange={(value, country) => setFormData({
                  ...formData,
                  phoneOffice: `+${country.dialCode} ${value.slice(country.dialCode.length)}`
                })}
                inputStyle={{
                  height: "58px",
                  width: "100%",
                  borderRadius: "5px",
                  paddingLeft: "48px",
                  paddingTop: "14px", // Creates space for floating label
                }}
                dropdownStyle={{ width: '250px' }}

              />
            </FormControl>
          </Grid>

          {/* Educational Details */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
              <Typography variant="h6" style={{ fontWeight: "bold" }}>Education Details</Typography>
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={addInstitution}
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  backgroundColor: buttonBackgroundColor,
                }}
              >
                Education
              </Button>
            </Box>
          </Grid>



          {formData.institutionDetails.map((institution, index) => (
            <Box key={index} sx={{ maxWidth: 770, margin: '0 auto' }}>
              <Grid container spacing={3} key={index}>
                <Grid item xs={12}>
                  <Typography variant="h6">Education {index + 1}</Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Institution"
                    name="institution"
                    value={institution.institution}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="From Year"
                    name="year"
                    value={institution.year}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                    margin="normal"
                  />
                </Grid>
                {/* <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    label="To Year"
                    name="toYear"
                    value={institution.toYear}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                    margin="normal"
                  />
                </Grid> */}
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth required margin="normal">
                    <InputLabel id={`full-time-part-time-label-${index}`}>Full Time or Part Time</InputLabel>
                    <Select
                      labelId={`full-time-part-time-label-${index}`}
                      label="Full Time or Part Time"
                      name="fullTimeOrPartTime"
                      value={institution.fullTimeOrPartTime}
                      onChange={(e) => handleInstitutionChange(index, e)}
                    >
                      <MenuItem value="Full Time">Full Time</MenuItem>
                      <MenuItem value="Part Time">Part Time</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Qualifications Achieved"
                    name="qualificationsAchieved"
                    value={institution.qualificationsAchieved}
                    onChange={(e) => handleInstitutionChange(index, e)}
                    required
                    margin="normal"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Tooltip title="Remove Institution">
                    <Button
                      variant="contained"
                      onClick={() => removeInstitution(index)}
                      sx={{
                        backgroundColor: "#dc3545", // Bootstrap Danger Red
                        color: "white",
                        "&:hover": {
                          backgroundColor: "#c82333", // Darker Red
                        },
                      }}
                    >
                      Remove
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            </Box>
          ))}

          {/* <Grid item xs={12}>
              <Button variant="outlined" startIcon={<Add />} onClick={addInstitution}>
                Add Institution
              </Button>
            </Grid> */}

          {/* Document Uploads */}
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom style={{ fontWeight: "bold" }}>Document Uploads</Typography>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Document</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Upload</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Status</TableCell>
                    <TableCell align="center" style={{ fontWeight: "bold" }}>Preview</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Mark Sheets */}
                  {formData.institutionDetails.map((institution, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">Mark Sheet {institution.institution}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          component="label"
                          sx={{
                            textTransform: "none",
                            
                            backgroundColor: buttonBackgroundColor,
                          }}
                          fullWidth
                          onClick={() => resetUpload(`markSheet-${index}`)}
                        >
                          {loadingButton === `markSheet-${index}` ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            formData.markSheet[`level${index + 1}`] ? "Re-upload" : "Upload"
                          )}                            <input
                            type="file"
                            name={`markSheet-${index}`}
                            hidden
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                            onChange={(e) => handleFileUpload(e, `markSheet-${index}`, index)}
                          />
                          {formData.markSheetProgress > 0 && formData.markSheetProgress < 100 && (
                            <LinearProgress variant="determinate" value={formData.markSheetProgress} sx={{ marginTop: 1 }} />
                          )}
                        </Button>
                      </TableCell>
                      <TableCell align="center">{formData.markSheet[`level${index + 1}Status`]}</TableCell>
                      <TableCell align="center">
                        {formData.markSheet[`level${index + 1}`] && (
                          <Button variant="contained" sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                          }}
                            color="primary" onClick={() => {
                              const fileType = isImage(formData.markSheet[`level${index + 1}`])
                                ? 'image'
                                : isPDF(formData.markSheet[`level${index + 1}`])
                                  ? 'pdf'
                                  : isDoc(formData.markSheet[`level${index + 1}`])
                                    ? 'doc'
                                    : 'unknown';
                              renderDoc(formData.markSheet[`level${index + 1}`],);
                            }}>
                            View
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Certificates */}
                  {formData.institutionDetails.map((institution, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">Certificate {institution.institution}</TableCell>
                      <TableCell align="center">
                        <Button
                          variant="contained"
                          color="primary"
                          component="label"
                          fullWidth
                          sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                          }}
                          onClick={() => resetUpload(`certificate-${index}`)}
                        >
                          {loadingButton === `certificate-${index}` ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            formData.certificate[`level${index + 1}`] ? "Re-upload" : "Upload"
                          )}                            <input
                            type="file"
                            name={`certificate-${index}`}
                            hidden
                            accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                            onChange={(e) => handleFileUpload(e, `certificate-${index}`, index)}
                          />
                          {formData.certificateProgress > 0 && formData.certificateProgress < 100 && (
                            <LinearProgress variant="determinate" value={formData.certificateProgress} sx={{ marginTop: 1 }} />
                          )}
                        </Button>
                      </TableCell>
                      <TableCell align="center">{formData.certificate[`level${index + 1}Status`]}</TableCell>
                      <TableCell align="center">
                        {formData.certificate[`level${index + 1}`] && (
                          <Button variant="contained" sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                          }}
                            color="primary" onClick={() => {
                              const fileType = isImage(formData.certificate[`level${index + 1}`])
                                ? 'image'
                                : isPDF(formData.certificate[`level${index + 1}`])
                                  ? 'pdf'
                                  : isDoc(formData.certificate[`level${index + 1}`])
                                    ? 'doc'
                                    : 'unknown';
                              renderDoc(formData.certificate[`level${index + 1}`],);
                            }}>
                            View
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Work Permit/Spass */}
                  <TableRow>
                    <TableCell align="center">Work Permit Front</TableCell>

                    {/* File Uploads for workPermitSpass and workPermitOne */}
                    <TableCell align="center">
                      {/* Upload for workPermitSpass */}
                      <Button 
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        backgroundColor: buttonBackgroundColor,
                      }}
                        variant="contained"
                        color="primary"
                        component="label"
                        fullWidth
                        onClick={() => resetUpload('workPermitSpass')}
                      >
                        {loadingButton === "workPermitSpass" ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          formData.workPermitSpass ? "Re-upload Work Permit front" : "Upload Work Permit front"
                        )}                          <input
                          type="file"
                          name="workPermitSpass"
                          hidden
                          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                          onChange={(e) => handleFileUpload(e, 'workPermitSpass')}
                        />
                        {formData.workPermitSpassProgress > 0 && formData.workPermitSpassProgress < 100 && (
                          <LinearProgress variant="determinate" value={formData.workPermitSpassProgress} sx={{ marginTop: 1 }} />
                        )}
                      </Button>

                      {/* Upload for workPermitOne */}
                      <Button
                        variant="contained"
                        color="primary"
                        component="label"
                        fullWidth
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: buttonBackgroundColor,
                          marginTop: '10px' 
                        }}
                     
                        onClick={() => resetUpload('workPermitOne')}
                      >
                        {loadingButton === "workPermitOne" ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          formData.workPermitOne ? "Re-upload Work Permit back" : "Upload Work Permit back"
                        )}                          <input
                          type="file"
                          name="workPermitOne"
                          hidden
                          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                          onChange={(e) => handleFileUpload(e, 'workPermitOne')}
                        />
                        {formData.workPermitOneProgress > 0 && formData.workPermitOneProgress < 100 && (
                          <LinearProgress variant="determinate" value={formData.workPermitOneProgress} sx={{ marginTop: 1 }} />
                        )}
                      </Button>
                    </TableCell>

                    {/* Status for both files */}
                    <TableCell align="center">
                      {formData.workPermitSpass ? 'Uploaded (Work Permit Front)' : ''}
                      <br />
                      {formData.workPermitOne ? 'Uploaded (Work Permit Back)' : ''}
                    </TableCell>

                    {/* View Buttons for both files */}
                    <TableCell align="center">
                      {/* View for workPermitSpass */}
                      {formData.workPermitSpass && (
                        <Button variant="contained"
                          color="primary"
                          sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                          }}
                          onClick={() => {
                            const fileType = isImage(formData.workPermitSpass)
                              ? 'image'
                              : isPDF(formData.workPermitSpass)
                                ? 'pdf'
                                : isDoc(formData.workPermitSpass)
                                  ? 'doc'
                                  : 'unknown';
                            renderDoc(formData.workPermitSpass, fileType);
                          }}
                        >
                          View Work Permit Front
                        </Button>
                      )}

                      {/* View for workPermitOne */}
                      {formData.workPermitOne && (
                        <Button variant="contained"
                          color="primary"
                          sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                            marginTop: '10px'
                          }}
                          onClick={() => {
                            const fileType = isImage(formData.workPermitOne)
                              ? 'image'
                              : isPDF(formData.workPermitOne)
                                ? 'pdf'
                                : isDoc(formData.workPermitOne)
                                  ? 'doc'
                                  : 'unknown';
                            renderDoc(formData.workPermitOne, fileType);
                          }}
                         
                        >
                          View Work Permit Back
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Passport */}
                  <TableRow>
                    <TableCell align="center">Passport</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        component="label"
                        fullWidth
                        onClick={() => resetUpload('passport')}
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: buttonBackgroundColor,
                        }}
                      >
                        {loadingButton === "passport" ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          formData.passport ? "Re-upload" : "Upload"
                        )}                          <input
                          type="file"
                          name="passport"
                          hidden
                          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
                          onChange={(e) => handleFileUpload(e, 'passport')}
                        />
                        {formData.passportProgress > 0 && formData.passportProgress < 100 && (
                          <LinearProgress variant="determinate" value={formData.passportProgress} sx={{ marginTop: 1 }} />
                        )}
                      </Button>
                    </TableCell>
                    <TableCell align="center">{formData.passport ? 'uploaded' : ''}</TableCell>
                    <TableCell align="center">
                      {formData.passport && (
                        <Button variant="contained"
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: buttonBackgroundColor,
                        }}
                          color="primary" onClick={() => {
                            const fileType = isImage(formData.passport)
                              ? 'image'
                              : isPDF(formData.passport)
                                ? 'pdf'
                                : isDoc(formData.passport)
                                  ? 'doc'
                                  : 'unknown';
                            renderDoc(formData.passport, fileType);
                          }}>
                          View
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>

                  {/* Profile Picture */}
                  <TableRow>
                    <TableCell align="center">Passport Size Photo</TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        color="primary"
                        component="label"
                        fullWidth
                        sx={{
                          textTransform: "none",
                          borderRadius: "8px",
                          backgroundColor: buttonBackgroundColor,
                        }}
                        onClick={() => resetUpload('profilePicture')}
                      >
                        {loadingButton === "profilePicture" ? (
                          <CircularProgress size={24} color="inherit" />
                        ) : (
                          formData.profilePicture ? "Re-upload" : "Upload"
                        )}                          <input
                          type="file"
                          name="profilePicture"
                          hidden
                          accept=".jpg, .jpeg, .png,.pdf"
                          onChange={(e) => handleFileUpload(e, 'profilePicture')}
                        />
                        {formData.profilePictureProgress > 0 && formData.profilePictureProgress < 100 && (
                          <LinearProgress variant="determinate" value={formData.profilePictureProgress} sx={{ marginTop: 1 }} />
                        )}
                      </Button>
                    </TableCell>
                    <TableCell align="center">{formData.profilePicture ? 'uploaded' : ''}</TableCell>
                    <TableCell align="center">
                      {formData.profilePicture && (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{
                            textTransform: "none",
                            borderRadius: "8px",
                            backgroundColor: buttonBackgroundColor,
                          }}
                          onClick={() => {
                            const fileType = isImage(formData.profilePicture)
                              ? 'image'
                              : isPDF(formData.profilePicture)
                                ? 'pdf'
                                : isDoc(formData.profilePicture)
                                  ? 'doc'
                                  : 'unknown';
                            renderDoc(formData.profilePicture, fileType);
                          }}>
                          View
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              type="submit"
              variant="contained"
              onClick={handleSave}
              color="secondary"
              style={{ marginRight: "10px" }}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: buttonBackgroundColor,
              }}
            >
              Save
            </Button>
            {from && (
              <Tooltip title="You can Approve this student save the Data"
                followCursor
                disableHoverListener={!isEdited}
                disableFocusListener={!isEdited}
                disableTouchListener={!isEdited}
                arrow>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={isEdited}
                  onClick={handleapprove}
                  sx={{
                    textTransform: "none",
                    borderRadius: "8px",
                    backgroundColor: buttonBackgroundColor,
                  }}
                  style={{
                    marginLeft: "10px",
                    pointerEvents: isEdited ? "auto" : "unset",
                  }}
                >
                  Approve
                </Button>
              </Tooltip>
            )}
          </Grid>

        </Grid>
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          maxWidth="sm"
          PaperProps={{ style: { borderRadius: 15, overflow: 'hidden' } }}
        >
          <DialogContent>
            {loading ? (
              <Box textAlign="center" py={4}>
                <CircularProgress />
                <Typography variant="h6" style={{ marginTop: 20 }}>
                  Submitting Your Form...
                </Typography>
              </Box>
            ) : (
              <Slide direction="up" in={submissionSuccess} mountOnEnter unmountOnExit>
                <Box textAlign="center" py={4}>
                  <CheckCircleIcon style={{ fontSize: 60, color: 'green' }} />
                  <Typography variant="h5" gutterBottom>
                    Form updated Successfully!
                  </Typography>
                  <Typography variant="body1" color="textSecondary">
                    You will be redirected to the home page shortly.
                  </Typography>
                </Box>
              </Slide>
            )}
          </DialogContent>
        </Dialog>
      </form>

      <Modal show={isConfirmModalOpen} onHide={closeConfirmModal}>
        <Modal.Header closeButton>
          <Modal.Title>Activate Student</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to activate this student?</p>

          <span style={{ color: 'red' }}>*</span>

          <TextField
            label="Remark"
            variant="outlined"
            margin="normal"
            fullWidth
            value={remark}
            onChange={(e) => setRemark(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="contained" onClick={closeConfirmModal}>
            Close
          </Button>
          <Button variant="contained" onClick={handleActivateStudent}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
}

export default EditStudent;
